import { render, staticRenderFns } from "./darg-img.vue?vue&type=template&id=1375e447&scoped=true"
import script from "./darg-img.vue?vue&type=script&lang=js"
export * from "./darg-img.vue?vue&type=script&lang=js"
import style0 from "./darg-img.vue?vue&type=style&index=0&id=1375e447&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1375e447",
  null
  
)

export default component.exports